import { isStringNullOrWhiteSpace } from 'owa-strings';
export default function createGenericItem(name, currentValidationState) {
    if (!isStringNullOrWhiteSpace(name)) {
        var personaToConvert = {
            primaryText: name,
            displayText: name,
            persona: {
                EmailAddress: {
                    MailboxType: 'OneOff',
                    RoutingType: 'SMTP',
                    EmailAddress: name,
                    Name: name,
                },
            },
            isValid: currentValidationState,
            isSelected: false,
            isExpanding: false,
            isContextMenuOpen: false,
        };
        return {
            selected: false,
            item: personaToConvert,
        };
    }
    else {
        return null;
    }
}
//# sourceMappingURL=createGenericItem.js.map